import { HouseholdPermissionAwareDisabledProvider } from '@/modules/authentication/context/HouseholdPermissionAwareDisabledProvider/HouseholdPermissionAwareDisabledProvider';
import { GratDesignerStages } from '@/navigation/constants';

import { RenderDesignerFooter } from '../types';
import { BasicInformationDesigner } from './BasicInformationDesigner/BasicInformationDesigner';
import { TabName } from './StructuringDesigner/constants';
import { StructuringDesigner } from './StructuringDesigner/StructuringDesigner';

export interface GRATDesignerProps {
  householdId: string;
  entityId: string;
  designerStage?: GratDesignerStages;
  initialStructuringTab: TabName;
  isFullScreenModal?: boolean;
  DesignerFooter?: RenderDesignerFooter;
  onAfterUpdate?: (
    afterUpdate: 'basicInformation' | 'structuring',
    entityId: string
  ) => void;
  onDelete?: () => void;
  onDirtyChange?: (isDirty: boolean) => void;
}

export function GRATDesigner({
  householdId,
  entityId,
  designerStage,
  isFullScreenModal = false,
  initialStructuringTab,
  DesignerFooter,
  onAfterUpdate,
  onDelete,
  onDirtyChange,
}: GRATDesignerProps) {
  if (designerStage === GratDesignerStages.BASIC_INFORMATION) {
    return (
      <HouseholdPermissionAwareDisabledProvider>
        <BasicInformationDesigner
          householdId={householdId}
          entityId={entityId}
          isFullScreenModal={isFullScreenModal}
          Footer={DesignerFooter}
          onAfterUpdate={(entityId) =>
            onAfterUpdate?.('basicInformation', entityId)
          }
          onDelete={onDelete}
          onDirtyChange={onDirtyChange}
        />
      </HouseholdPermissionAwareDisabledProvider>
    );
  } else if (designerStage === GratDesignerStages.STRUCTURING) {
    return (
      <HouseholdPermissionAwareDisabledProvider>
        <StructuringDesigner
          householdId={householdId}
          entityId={entityId}
          initialTab={initialStructuringTab}
          isFullScreenModal={isFullScreenModal}
          Footer={DesignerFooter}
          onAfterUpdate={(entityId) => onAfterUpdate?.('structuring', entityId)}
          onDelete={onDelete}
          onDirtyChange={onDirtyChange}
        />
      </HouseholdPermissionAwareDisabledProvider>
    );
  } else {
    throw new Error(`Unknown designer stage: ${designerStage}`);
  }
}
